__turbopack_context__.v({
  "btn": "style-module-scss-module__Y4LMNW__btn",
});
